export const UPGRADE_CHANNEL_UNKNOWN_LABEL = 'Unknown';

const UPGRADE_CHANNELS = {
	ga: { label: 'GA', appearance: 'secondary' },
	rc: { label: 'RC', appearance: 'info' },
	beta: { label: 'Beta', appearance: 'warning' },
	alpha: { label: 'Alpha', appearance: 'danger' }
};

const knownUpgradeChannel = (channel) => {
	if (typeof channel !== 'string') {
		return null;
	}

	return UPGRADE_CHANNELS[channel.trim().toLowerCase()] ?? null;
};

/**
 * The appliance reports its installed channel as free text, so unknown values are expected.
 * They stay neutral because we cannot tell whether they are pre-release.
 */
export const upgradeChannelAppearance = (channel) => {
	return knownUpgradeChannel(channel)?.appearance ?? 'secondary';
};

/**
 * Products that never synced report no channel at all; they must read as unknown, not blank.
 * Unrecognised channels are labelled with the reported value itself.
 */
export const upgradeChannelLabel = (channel) => {
	const knownChannel = knownUpgradeChannel(channel);
	if (knownChannel) {
		return knownChannel.label;
	}

	if (typeof channel !== 'string' || !channel.trim()) {
		return UPGRADE_CHANNEL_UNKNOWN_LABEL;
	}

	return channel.trim();
};
